import { render, staticRenderFns } from "./PartnerChangePasswordDetail.vue?vue&type=template&id=5ad7669c&"
import script from "./PartnerChangePasswordDetail.vue?vue&type=script&lang=js&"
export * from "./PartnerChangePasswordDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports